/**
 * Formats a date string to the format YYYY-MM-DD
 * @param date - The date string to format
 * @returns The formatted date string
 */
export const formatDate = (date: string) => {
	const d = new Date(date);
	const year = d.getFullYear();
	const month = String(d.getMonth() + 1).padStart(2, '0');
	const day = String(d.getDate()).padStart(2, '0');

	return `${year}-${month}-${day}`;
};
